import { render, staticRenderFns } from "./BookOpenOutline.vue?vue&type=template&id=61e25504&"
import script from "./BookOpenOutline.vue?vue&type=script&lang=ts&"
export * from "./BookOpenOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports